import { render, staticRenderFns } from "./DocumentPageNavigator.vue?vue&type=template&id=f65beadc&scoped=true&"
import script from "./DocumentPageNavigator.vue?vue&type=script&lang=ts&"
export * from "./DocumentPageNavigator.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentPageNavigator.vue?vue&type=style&index=0&id=f65beadc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65beadc",
  null
  
)

export default component.exports